var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
// Context
export var DocumentIdsContext = React.createContext({
    documentIds: [],
    insertDocumentId: function (newValue) { },
    extraQueryParams: {},
});
// Provider
export var DocumentIdsProvider = function (props) {
    var children = props.children, templateId = props.templateId, templateDocumentId = props.templateDocumentId;
    // State
    var _a = React.useState({
        templateId: templateId,
        templateDocumentId: templateDocumentId,
    }), extraQueryParams = _a[0], setExtraQueryParams = _a[1];
    var _b = React.useState(props.documentIds), documentIds = _b[0], setDocumentIds = _b[1];
    React.useEffect(function () {
        setExtraQueryParams({
            templateId: templateId,
            templateDocumentId: templateDocumentId,
        });
    }, [templateId, templateDocumentId]);
    // Helpers
    var insertDocumentId = function (newValue) {
        setDocumentIds(__spreadArray(__spreadArray([], documentIds, true), [newValue], false));
    };
    // Render
    return (_jsx(DocumentIdsContext.Provider, { value: {
            documentIds: documentIds,
            insertDocumentId: insertDocumentId,
            extraQueryParams: extraQueryParams,
        }, children: children }));
};
